<template>
    <section id="subscriptionDiv">
        <div class="container mt-5">
            <div class="px-4 py-5 px-md-5 text-center text-lg-start">
                <div class="container">
                    <div class="row gx-lg-5 align-items-center">
                        <h3 class="mb-4 text-center text-uppercase fw-bold text-primary">
                            Choose Your Plan
                        </h3>
                        <h4 class="mb-1 text-center text-sec">
                            Improve your business with our outstanding destinations APIs.
                        </h4>
                        <div class="col-lg-12">
                            <div class="" style="background-color: #ffffff; border-radius: 15px;">
                                <div class="card-body py-5 px-md-5">

                                    <div v-if="packages.length > 0" class="row gy-4">
                                        <!-- Package Card -->
                                        <div v-for="(pkg, index) in packages" :key="index"
                                            class="col-md-12 col-lg-6 d-flex align-items-stretch">
                                            <div class="package-card p-4 border rounded shadow-sm w-100">
                                                <h1 class="text-primary text-uppercase fw-bold text-center">
                                                    {{ pkg.name }}
                                                </h1>
                                                <p class="text-center fs-3">
                                                    <strong class="text-sec">${{ pkg.price }}</strong> / month
                                                </p>
                                                <div class="d-flex justify-content-center">
                                                    <button
                                                        class=" col-12 btn btn-primary btn-lg text-uppercase px-4 mt-3"
                                                        @click="goToPurchse(pkg)">
                                                        Purchase
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="text-center">
                                        <p class="text-muted fs-5">No packages available at the moment.</p>
                                    </div>
                                    <div class="alert alert-danger mt-3" v-if="error">
                                        {{ error }}
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import $ from 'jquery';
import { loadStripe } from '@stripe/stripe-js';
import Swal from 'sweetalert2';


export default {
    name: 'SubscriptionPage',
    data() {
        return {
            packages: [], // Holds fetched packages
            error: null,  // Holds error messages
        };
    },
    mounted() {
        this.fetchPackages();
        // Initialize Stripe


    },
    methods: {

        fetchPackages() {
            const apiUrl = process.env.VUE_APP_API_URL +'/getEnableApiPackages';
            $.ajax({
                url: apiUrl,
                method: 'GET',
                success: (response) => {
                    this.packages = response;
                },
                error: (xhr) => {
                    this.error = 'Error fetching packages. Please try again later.';
                    console.error(xhr.responseJSON.message);
                },
            });
        },
        // Navigate to the plan details page
        goToPurchse(pkg) {
            const stripe = Stripe(process.env.VUE_Stripe_Key); // Your Stripe public key

            const price = pkg.price;
            const name = pkg.name;

            var user = JSON.parse(localStorage.getItem('user'));
            if (!user || !user.id) {
                Swal.fire({
                    title: 'Login Required',
                    text: 'Please log in to proceed with the purchase.',
                    icon: 'warning',
                    confirmButtonText: 'Login',
                }).then(() => {
                    this.$router.push('/login'); // Redirect to the login page
                });
                return;
            }

            var userId = user.id;

            const successUrl = process.env.Vue_APP_URL +'/pay-success'; // Vue success URL
            const cancelUrl = process.env.Vue_APP_URL +'/pay-fail'; // Vue failure URL

            // Make an AJAX request to your backend to create a Checkout session
            $.ajax({
               url: process.env.VUE_APP_API_URL +'/create-api-package-checkout-session',
                method: 'POST',
                data: {
                    id: userId,
                    price: price,
                    name: name,
                    success_url: successUrl, // Pass the success URL
                    cancel_url: cancelUrl,   // Pass the failure URL
                },
                success: (response) => {
                    // Redirect to Stripe Checkout
                    stripe.redirectToCheckout({ sessionId: response.sessionId }).then((result) => {
                        if (result.error) {
                            Swal.fire({
                                title: 'Payment Failed',
                                text: result.error.message,
                                icon: 'error',
                                confirmButtonText: 'Retry',
                            }).then(() => {
                                this.$router.push('/payment-failure'); // Navigate to the failure page
                            });
                        }
                    });
                },
                error: (error) => {
                    console.error('Error creating checkout session:', error);
                    Swal.fire({
                        title: 'Error',
                        text: 'An error occurred while processing your payment.',
                        icon: 'error',
                        confirmButtonText: 'OK',
                    });
                }
            });
        }


    },
};
</script>

<style scoped>
.card {
    border: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}

.package-card {
    background: #f8f9fa;
    transition: transform 0.3s, box-shadow 0.3s;
}

.package-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.2);
}

h4 {
    color: #5a5a5a;
}

button {
    background-color: #37a2d3;
    border: none;
    transition: background-color 0.3s;
}

button:hover {
    background-color: #bd0606;
    color: #ffffff;
}

.alert {
    font-size: 0.9rem;
}

.text-primary {
    color: #bd0606 !important;
}

.text-sec {
    color: #37a2d3 !important;
}
</style>
